<template>
	<div class="notice_popup view info">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="view-tit" v-if="forwardData.div == 'tec'">회원개인정보</div>
		<div class="view-tit" v-else-if="forwardData.div == 'gmg'">클라이언트_관리총괄 개인정보</div>
		<div class="view-tit" v-else-if="forwardData.div == 'pmg'">클라이언트_프로젝트 담당 개인정보</div>
		<div class="view-tit" v-else-if="forwardData.div == 'sco'">파트너사_담당자 개인정보</div>
		<div class="view-tit" v-else-if="forwardData.div == 'agt'"><img class="hp_agent" src="/images/admin/highpro_agent.png" alt="그레이트프로매니저"/>그레이트프로 매니저</div>
		<div class="view-tit" v-else-if="forwardData.div == 'adm'">그레이트프로 관리자 개인정보</div>
		<div class="mem_count">{{forwardData.div == 'adm' ? '관리자번호':'회원번호'}}<span class="count">{{mberInfo.mberSeq}}</span></div>
		<div class="view">
			<div class="list">
				<div class="label">성명</div><div class="contents">{{mberInfo.mberNm}}</div><div class="mf_btn" v-if="'agt,adm'.indexOf(forwardData.div) > -1" @click="pageMove(mberInfo.mberSeq)">정보수정 &#9654;</div>
			</div>
			<div class="list">
				<div class="label"><span v-if="'agt,adm'.indexOf(forwardData.div) > -1">담당자 아이디</span><span v-else>회원아이디</span></div><div class="contents">{{mberInfo.loginId}}</div>
			</div>
			<div class="list">
				<div class="label">휴대폰번호</div><div class="contents">{{mberInfo.hpNo | cell}}</div>
			</div>
			<div class="list">
				<div class="label">이메일</div><div class="contents">{{mberInfo.email}}</div>
			</div>
			<div class="list" v-if="'agt,adm'.indexOf(forwardData.div) < 0">
				<div class="label">이메일 수신여부</div><div class="contents">{{mberInfo.emailRecvYn == 'Y' ? '동의':'미동의'}}</div>
			</div>
			<div class="list" v-if="'agt,adm'.indexOf(forwardData.div) < 0">
				<div class="label">SMS 수신여부</div><div class="contents">{{mberInfo.smsRecvYn == 'Y' ? '동의':'미동의'}}</div>
			</div>
			<div class="list" v-if="forwardData.div == 'tec'">
				<div class="label">회원소속사</div><div class="contents">{{mberInfo.corpNm || '-'}}</div>
			</div>
			<!-- <div class="list" v-if="forwardData.div == 'tec'">
				<div class="label">참여소속사</div><div class="contents">{{mberInfo.projectJoinCorpNm || '-'}}</div>
			</div> -->
			<div class="list" v-if="forwardData.div == 'tec'">
				<div class="label">직원구분</div><div class="contents"><SelectComp type="text" cdId="PRO102" v-model="mberInfo.empDivCd" /></div>
			</div>
			<div class="list" v-if="forwardData.div == 'tec'">
				<div class="label">생년월일</div><div class="contents">{{mberInfo.birthYyyymmdd | date('yyyy.MM.dd')}}</div>
			</div>
			<!-- <div class="list" v-if="forwardData.div == 'sco'">
				<div class="label">산업분야</div><div class="contents"><SelectComp type="text" cdId="PRO105" v-model="mberInfo.indtypeClassCd" /></div>
			</div> -->
			<div class="list" v-if="'tec,agt,adm'.indexOf(forwardData.div) < 0">
				<div class="label">회사명</div><div class="contents">{{mberInfo.corpNm}}</div>
			</div>
			<div class="list" v-if="forwardData.div == 'pmg'">
				<div class="label">부서명</div><div class="contents">{{mberInfo.deptNm}}</div>
			</div>
			<div class="list" v-if="'pmg,agt,adm'.indexOf(forwardData.div) > -1">
				<div class="label">직급</div><div class="contents">{{mberInfo.positionNm}}</div>
			</div>
			<div class="list" v-if="'agt,adm'.indexOf(forwardData.div) > -1">
				<div class="label">담당분야</div><div class="contents"><SelectComp type="text" cdId="PRO101" v-model="mberInfo.mberDivCd"/></div>
			</div>
			<div class="list" v-if="'tec,agt,adm'.indexOf(forwardData.div) > -1">
				<div class="label">성별</div><div class="contents">{{mberInfo.gender | gender}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props : ['param'],
	data() {
		return {
			mberInfo : {},

			forwardData : this.param,
		}
	},

	mounted() {
		//console.log('param', this.param);
		
		this.getDcoGmgInfo()
	},

	methods : {
		getDcoGmgInfo() {
			this.$.httpPost('/api/mem/adm/dco/getDcoGmgInfo', this.forwardData)
				.then(res => {
					this.mberInfo = res.data.mberInfo;
					
					this.$emit('updated');
				}).catch(this.$.httpErrorCommon);
		},

		pageMove(seq) {
			this.$router.push({name:'MEM970M03', params:{admMberSeq:seq}});
			this.$emit('close');
		}
	}
}
</script>